import React from "react";
import MuPb from "../../../../widgets/MuPb";
import { Alert, Box } from "@mui/material";
import ProfileDetails from "./ProfileDetails";
import { useSearchParams } from "react-router-dom";
import { VISITOR } from "../../../../constants/constants";
import BackBtn from "../../../../widgets/BackBtn";
import useApiEp from "../../../../hooks/useApiEp";

const ProfileViewByID = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const { isLoading, isError, error, data } = useApiEp(
    `/user/get-user-by-id?id=${id}`
  );
  if (isLoading) {
    return <MuPb />;
  }
  if (isError) {
    return <Alert security="error">{error.message}</Alert>;
  }
  return (
    <Box>
      <Box ml={2} mt={1}>
        <BackBtn />
      </Box>
      {data.role === VISITOR ? (
        <></>
      ) : (
        <ProfileDetails user={data} isView={true} id={id} />
      )}
    </Box>
  );
};

export default ProfileViewByID;
